import { bool, node, object, string } from "prop-types";
import { memo, useMemo } from "react";

import styled from "styled-components";

import FnrOpacityToggle from "UI/FnrOpacityToggle";
import FnrScrollNFade from "UI/FnrScrollNFade";
import { colors, navAccentColors } from "UI/colors";

const MainContents = memo(
  ({ show, scrollRef, contentRef, maxHeight, navSectionKey, children }) => {
    const scrollbar = useMemo(
      () => ({
        color: navAccentColors[navSectionKey][0],
        backgroundColor: colors.transparent,
      }),
      [navSectionKey]
    );
    return (
      <FnrOpacityToggle show={show}>
        <FnrScrollNFade
          ref={scrollRef}
          fullWidth
          maxHeight={maxHeight}
          clipX
          scrollbar={scrollbar}
          fadeThickness={52}
          paused={!show}
        >
          <ChildrenWrapper ref={contentRef}>{children}</ChildrenWrapper>
        </FnrScrollNFade>
      </FnrOpacityToggle>
    );
  }
);

MainContents.propTypes = {
  show: bool,
  scrollRef: object,
  contentRef: object,
  maxHeight: string,
  children: node,
  navSectionKey: string,
};

const ChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default MainContents;
